(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ow-country-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ow-country-selector')) {
    customElements.define('ow-country-selector', class extends HTMLElement {
      connectedCallback() {
        this.onchange = () => this.querySelector('form').requestSubmit();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ow-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-wood-guide"]) return;
  try {
    
  if (Shopify.designMode) {
    let guideSelected = false;

    /**
     * @param {Event} event
     * @returns {import('@theme/dialog').DialogComponent | null}
     */
    function selectedWoodGuide(event) {
      if (!(event.target instanceof Element)) return null;

      return /** @type {import('@theme/dialog').DialogComponent | null} */ (
        event.target.closest('.shopify-section')?.querySelector('dialog-component.ow-wood-guide') ?? null
      );
    }

    /** @param {Event} event */
    async function showSelectedWoodGuide(event) {
      const guide = selectedWoodGuide(event);
      if (!guide) return;

      guideSelected = true;
      await customElements.whenDefined('dialog-component');
      if (!guide.isConnected || !guideSelected) return;

      guide.showDialog();
    }

    document.addEventListener('shopify:section:select', showSelectedWoodGuide);
    document.addEventListener('shopify:block:select', showSelectedWoodGuide);
    document.addEventListener('shopify:section:load', (event) => {
      if (guideSelected) showSelectedWoodGuide(event);
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      const guide = selectedWoodGuide(event);
      if (!guide) return;

      guideSelected = false;
      guide.closeDialog?.();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
